import React from "react";

const SectionLoader = ({ text = "Loading...", withoutText = false }) => {
  return (
    <div className="flex flex-col items-center justify-center p-5 rounded-lg w-full min-h-[120px] text-center font-sans text-white">
      <div className="w-10 h-10 mb-2 border-4 rounded-full dark:border-white/10 border-black/10 dark:border-t-primary border-t-primary-light animate-spin"></div>
      {/* {!withoutText && <p>{text}</p>} */}
    </div>
  );
};

export default SectionLoader;
